<script>
import { SocialSvg } from "./SocialIcon";
export default {
    props: {
        data: {
            required: true
        },
        base_url: {
            required: false,
            type: String
        }
    },
    data() {
        return {
            loading: false,
            api_url: this.base_url,
            linktree: {}
        };
    },
    methods: {
        async getData() {
            this.loading = true;
            if (this.data.id) {
                await axios
                    .get(`${this.api_url}/api/linktree/${this.data.id}`)
                    .then(res => {
                        this.linktree = res.data.data;
                        this.loading = false;
                    })
                    .catch(err => {
                        this.loading = false;
                        console.log(err.response.data);
                    });
            }
        }
    },
    mounted() {
        this.getData();
    }
};
</script>
<template>
    <div v-if="!loading">
        <linktree-component v-bind="linktree" />
    </div>
</template>
